import $, { Cash } from 'cash-dom'
import { proxy } from '../../resources/proxy'

class ReferralForm {
  container: Cash
  content: Cash
  formStep1: Cash
  formStep2: Cash
  successDiv: Cash
  getLinkButton: Cash
  sendEmailButton: Cash
  resetButton: Cash
  referrerEmailInput: Cash
  friendEmailInput: Cash
  formErrorStep1: Cash
  formErrorStep2: Cash
  referrerEmail: string
  referralLink: string

  constructor(container: Cash) {
    this.container = $(container)
    this.content = this.container.find('[data-referral-content-container]')
    this.formStep1 = this.container.find('[data-yotpo-referral-form-step1]')
    this.formStep2 = this.container.find('[data-yotpo-referral-form-step2]')
    this.successDiv = this.container.find('[data-yotpo-referral-success]')

    this.getLinkButton = this.formStep1.find(
      '[data-action="get-referral-link"]'
    )

    this.sendEmailButton = this.formStep2.find(
      '[data-action="send-referral-email"]'
    )
    this.resetButton = this.successDiv.find('[data-action="reset-form"]')

    this.referrerEmailInput = this.formStep1.find('[name="referrer_email"]')
    this.friendEmailInput = this.formStep2.find('[name="friend_email"]')

    this.formErrorStep1 = this.formStep1.find('[data-form-error]')
    this.formErrorStep2 = this.formStep2.find('[data-form-error]')

    this.referrerEmail = ''
    this.referralLink = ''

    if (this.referrerEmailInput.prop('readonly')) {
      this.getLinkButton.prop('disabled', false)
      this.referrerEmailInput.closest('.input-group').attr('data-valid', 'true')
    }

    this.bindEvents()
  }

  bindEvents() {
    this.formStep1.on('submit', (e) => this.handleStep1Submit(e))
    this.formStep2.on('submit', (e) => this.handleStep2Submit(e))
    this.resetButton.on('click', () => this.resetForm())
  }

  async handleStep1Submit(e: Event) {
    e.preventDefault()
    this.formErrorStep1.addClass('hidden').text('')
    this.referrerEmail = this.referrerEmailInput.val() as string
    this.getLinkButton.prop('disabled', true)

    try {
      const { data } = await proxy('/referral/identify-referrer', {}, 'POST', {
        email: this.referrerEmail,
      })

      if (data.referral_link) {
        this.referralLink = data.referral_link

        this.formStep1.addClass('hidden')
        this.formStep2.removeClass('hidden')
        this.friendEmailInput[0].focus()
      } else {
        this.formErrorStep1
          .text(data.message ?? 'Could not get referral link.')
          .removeClass('hidden')

        setTimeout(() => {
          this.formErrorStep1.addClass('hidden').text('')
        }, 5000)
      }
    } catch (error) {
      console.error('Get referral link error:', error)
      this.formErrorStep1
        .text('A network error occurred. Please try again.')
        .removeClass('hidden')

      setTimeout(() => {
        this.formErrorStep1.addClass('hidden').text('')
      }, 5000)
    }
  }

  async handleStep2Submit(e: Event) {
    e.preventDefault()

    this.formErrorStep2.addClass('hidden').text('')
    const friendEmail = this.friendEmailInput.val()

    try {
      const response = await proxy('/referral/send-emails', {}, 'POST', {
        email: this.referrerEmail,
        emails: friendEmail,
      })

      if (response.error) {
        let errorMessage = response.message ?? 'Could not send referral email.'
        if (
          response.details &&
          Array.isArray(response.details) &&
          response.details.length > 0
        ) {
          errorMessage = 'Some emails could not be processed:'
          response.details.forEach((detail: any) => {
            const reasonText = detail.reason
              ? detail.reason.replace(/_/g, ' ').toLowerCase()
              : 'invalid email'
            errorMessage += ` ${detail.email} (${reasonText}),`
          })
          errorMessage = errorMessage.replace(/,$/, '.')
        }

        this.formErrorStep2.text(errorMessage).removeClass('hidden')

        setTimeout(() => {
          this.formErrorStep2.addClass('hidden').text('')
        }, 5000)
        return
      }

      this.formStep2.addClass('hidden')
      this.content.addClass('hidden')
      this.successDiv.removeClass('hidden')
    } catch (error) {
      console.error('Send referral email error:', error)
      this.formErrorStep2
        .text('A network error occurred. Please try again.')
        .removeClass('hidden')

      setTimeout(() => {
        this.formErrorStep2.addClass('hidden').text('')
      }, 5000)
    }
  }

  resetForm() {
    if (!this.referrerEmailInput.prop('readonly')) {
      this.referrerEmailInput.val('')
      this.getLinkButton.prop('disabled', true)
    } else {
      this.getLinkButton.prop('disabled', false)
      this.referrerEmailInput.closest('.input-group').attr('data-valid', 'true')
    }

    this.friendEmailInput.val('')
    this.referrerEmail = ''
    this.referralLink = ''
    this.formErrorStep1.addClass('hidden').text('')
    this.formErrorStep2.addClass('hidden').text('')
    this.container.find('[data-validate]').attr('data-valid', '')
    this.container.find('.input-group-error').addClass('hidden').text('')

    this.content.removeClass('hidden')
    this.formStep1.removeClass('hidden')
    this.formStep2.addClass('hidden')
    this.successDiv.addClass('hidden')
  }
}

$(document).ready(() => {
  $('[data-referral-form-container]').each((_, el) => {
    const _formInstance = new ReferralForm(el)
  })
})
